"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

var _computePoint = _interopRequireDefault(require("./utils/computePoint"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _pixelToNumber = _interopRequireDefault(require("../style/pixelToNumber"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _INumber = _interopRequireDefault(require("../../common/iObjects/INumber"));

var _root = _interopRequireDefault(require("./style/root"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var _progress = _interopRequireDefault(require("./style/progress"));

var _barWrapper = _interopRequireDefault(require("./style/barWrapper"));

var _bar = _interopRequireDefault(require("./style/bar"));

var _pointer = _interopRequireDefault(require("./style/pointer"));

var _ownerDocument = _interopRequireDefault(require("../../utils/ownerDocument"));

var _userAgent = _interopRequireDefault(require("../../common/userAgent.0.0.3"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _hint = _interopRequireDefault(require("./style/hint"));

var _hintTriangle = _interopRequireDefault(require("./style/hintTriangle"));

var _computeProgress3 = _interopRequireDefault(require("./utils/computeProgress"));

var _calculateWidth = _interopRequireDefault(require("./utils/calculateWidth"));

var _calculateLeft = _interopRequireDefault(require("./utils/calculateLeft"));

var valueSetter = function valueSetter(_ref) {
  var value = _ref.value,
      name = _ref.name,
      onChange = _ref.onChange;
  var target = {
    value: value,
    name: name,
    type: 'input'
  };

  if (typeof onChange === 'function') {
    onChange((0, _syntheticEvent["default"])(target));
  }
};

var IntervalPeriod = function IntervalPeriod(_ref2) {
  var disabled = _ref2.disabled,
      value = _ref2.value,
      onChange = _ref2.onChange,
      name = _ref2.name,
      roundingAccuracy = _ref2.roundingAccuracy,
      end = _ref2.end,
      start = _ref2.start,
      step = _ref2.step,
      style = _ref2.style,
      theme = _ref2.theme,
      className = _ref2.className,
      hint = _ref2.hint;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      fromPointer = _useState4[0],
      setFromPointer = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      toPointer = _useState6[0],
      setToPointer = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      clickable = _useState8[0],
      setClickable = _useState8[1];

  var progress = (0, _react.useRef)(null);
  var bar = (0, _react.useRef)(null);
  var handleDragEnd = (0, _react.useCallback)(function () {
    setFocused(false);
    setFromPointer(false);
    setToPointer(false);
    setClickable(true);
  }, []);
  var dragStart = (0, _react.useCallback)(function () {
    setFocused(true);
    setClickable(false);
  }, []);
  var handleFromStart = (0, _react.useCallback)(function () {
    if (!disabled) {
      setFromPointer(true);
      dragStart();
    }
  }, [disabled]);
  var handleToStart = (0, _react.useCallback)(function () {
    if (!disabled) {
      setToPointer(true);
      dragStart();
    }
  }, [disabled]);
  var handleClick = (0, _react.useCallback)(function (e) {
    if (!disabled) {
      var _progress$current;

      var _ref3 = value || [],
          _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
          _from = _ref4[0],
          _to = _ref4[1],
          point = (0, _computePoint["default"])({
        x: e.pageX,
        roundingAccuracy: roundingAccuracy,
        end: end,
        start: start,
        step: step,
        offset: (0, _documentOffset["default"])(progress.current),
        offsetWidth: (_progress$current = progress.current) === null || _progress$current === void 0 ? void 0 : _progress$current.offsetWidth
      });

      var nextFrom = _from,
          nextTo = _to;

      if (isNaN(_from)) {
        nextFrom = point;
      } else if (isNaN(_to)) {
        nextTo = point;
      } else {
        if (point > _from) {
          nextTo = point;
        } else if (point < _from) {
          nextFrom = point;
        }
      }

      valueSetter({
        value: [nextFrom, nextTo],
        onChange: onChange,
        name: name
      });
    }
  }, [disabled, value]);
  var handleMouseMove = (0, _react.useCallback)(function (event) {
    if (focused) {
      var _ref5 = value || [],
          _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
          _from2 = _ref6[0],
          _to2 = _ref6[1],
          _computeProgress = (0, _computeProgress3["default"])({
        event: event,
        toPointer: toPointer,
        fromPointer: fromPointer,
        step: step,
        start: start,
        roundingAccuracy: roundingAccuracy,
        end: end,
        progressBar: progress.current,
        value: value
      }),
          _computeProgress2 = (0, _slicedToArray2["default"])(_computeProgress, 2),
          nextFrom = _computeProgress2[0],
          nextTo = _computeProgress2[1];

      if (_from2 !== nextFrom || _to2 !== nextTo) {
        valueSetter({
          value: [nextFrom, nextTo],
          onChange: onChange,
          name: name
        });
      }
    }
  }, [focused, value]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  var left = (0, _react.useMemo)(function () {
    var _bar$current;

    return (0, _calculateLeft["default"])({
      value: value,
      start: start,
      end: end,
      pointerWidth: memoTheme.pointerWidth,
      width: (_bar$current = bar.current) === null || _bar$current === void 0 ? void 0 : _bar$current.offsetWidth
    });
  }, [value, start, end, memoTheme, bar.current]);
  var width = (0, _react.useMemo)(function () {
    return (0, _calculateWidth["default"])({
      end: end,
      start: start,
      value: value
    });
  }, [end, start, value]);

  var _value = (0, _slicedToArray2["default"])(value, 2),
      from = _value[0],
      to = _value[1];

  return _react["default"].createElement(_root["default"], {
    theme: memoTheme,
    className: className
  }, _react["default"].createElement(_wrapper["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_reactEventListener["default"], {
    target: (0, _ownerDocument["default"])(progress.current).querySelector('body'),
    onMouseMove: _userAgent["default"].browser.isMobileDevice ? undefined : handleMouseMove,
    onTouchMove: _userAgent["default"].browser.isMobileDevice ? handleMouseMove : undefined,
    onMouseUp: _userAgent["default"].browser.isMobileDevice ? undefined : handleDragEnd,
    onTouchEnd: _userAgent["default"].browser.isMobileDevice ? handleDragEnd : undefined
  }), _react["default"].createElement(_progress["default"], {
    theme: memoTheme,
    onClick: clickable ? handleClick : null,
    ref: progress
  }, _react["default"].createElement(_barWrapper["default"], {
    theme: memoTheme,
    ref: bar
  }, _react["default"].createElement(_bar["default"], {
    theme: memoTheme,
    style: {
      width: width + '%',
      left: left
    },
    disabled: disabled,
    focused: focused
  }, _react["default"].createElement(_pointer["default"], {
    type: "button",
    theme: memoTheme,
    onMouseDown: _userAgent["default"].browser.isMobileDevice ? null : handleFromStart,
    onTouchStart: _userAgent["default"].browser.isMobileDevice ? handleFromStart : null,
    disabled: disabled,
    focused: focused
  }, hint && focused && from && fromPointer ? _react["default"].createElement(_hint["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_hintTriangle["default"], {
    theme: memoTheme
  }), from) : null), _react["default"].createElement(_pointer["default"], {
    type: "button",
    theme: memoTheme,
    onMouseDown: _userAgent["default"].browser.isMobileDevice ? null : handleToStart,
    onTouchStart: _userAgent["default"].browser.isMobileDevice ? handleToStart : null,
    disabled: disabled,
    focused: focused
  }, hint && focused && to && toPointer ? _react["default"].createElement(_hint["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_hintTriangle["default"], {
    theme: memoTheme
  }), to) : null))))));
};

IntervalPeriod.defaultProps = {
  step: 1
};
IntervalPeriod.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].array]),
  onChange: _propTypes["default"].func,
  onDrag: _propTypes["default"].func,
  start: _propTypes["default"].number.isRequired,
  step: _propTypes["default"].number.isRequired,
  end: _propTypes["default"].number.isRequired,
  roundingAccuracy: _propTypes["default"].number,
  hint: _propTypes["default"].bool,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  theme: _propTypes["default"].object,
  disabled: _propTypes["default"].bool
};
var _default = IntervalPeriod;
exports["default"] = _default;